// Singleton store: open comment count → rail badge.
// Mirrors the subscribe pattern from people-directory.ts.

type CountListener = () => void;

let openCount: number = 0;
const listeners: Set<CountListener> = new Set();

function emit(): void {
  for (const listener of listeners) listener();
}

export function getOpenCount(): number {
  return openCount;
}

export function setOpenCount(n: number): void {
  if (openCount === n) return;
  openCount = n;
  emit();
}

export function subscribeOpenCount(listener: CountListener): () => void {
  listeners.add(listener);
  return (): void => {
    listeners.delete(listener);
  };
}
